import { useEffect, useState } from "react";

function getPortalRoot() {
  if (typeof document === "undefined") {
    return undefined;
  }

  // Fullscreen is requested on #root; portals outside it are invisible.
  return (
    (document.fullscreenElement as HTMLElement | null) ??
    document.getElementById("root") ??
    document.body
  );
}

const usePortalRoot = () => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null | undefined>(
    getPortalRoot,
  );

  useEffect(() => {
    const updatePortalRoot = () => {
      setPortalRoot(getPortalRoot());
    };

    updatePortalRoot();
    document.addEventListener("fullscreenchange", updatePortalRoot);
    document.addEventListener("webkitfullscreenchange", updatePortalRoot);
    document.addEventListener("mozfullscreenchange", updatePortalRoot);

    return () => {
      document.removeEventListener("fullscreenchange", updatePortalRoot);
      document.removeEventListener("webkitfullscreenchange", updatePortalRoot);
      document.removeEventListener("mozfullscreenchange", updatePortalRoot);
    };
  }, []);

  return portalRoot;
};

export default usePortalRoot;
